import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  loader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    flex: "1 1 auto",
    width: "100%",
    height: "100vh",
  },
  logo: {
    width: "100%",
    maxWidth: 214,
    fontSize: 0,
    '& img': {
      width: "100%",
      height: "auto",
    },
  },
  small: {
    maxWidth: 80,
  },
  large: {
    maxWidth: 320,
  },
  progress: {
    width: "100%",
    maxWidth: "100%",
    position: "absolute",
    left: 0,
    top: 0,
  },
}));
